import { connectedStore } from '../../store';
import globals from '../../globals';

const getPlaceToInsertSiteDependencies = (liveDocument) => {
  let position = 'beforeend';
  let element = liveDocument.body;

  const store = connectedStore.get();
  const state = store.getState();
  const footerCodeGlobal = globals.selectors.getGlobal(state, 'footer-code');

  if (footerCodeGlobal && footerCodeGlobal.source) {
    const footerCodeNode = liveDocument.querySelector(
      `${globals.constants.GLOBAL_TAG_NAME}[src="${footerCodeGlobal.source}"]`
    );

    if (footerCodeNode) {
      position = 'beforebegin';
      element = footerCodeNode;
    }
  }

  return {
    position,
    element,
  };
};

export default getPlaceToInsertSiteDependencies;
